import { render, staticRenderFns } from "./LogoDashboard.vue?vue&type=template&id=476de0fa&"
import script from "./LogoDashboard.vue?vue&type=script&lang=js&"
export * from "./LogoDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports